import Axios from '../Axios'

const stats = {
  general(params) {
    return Axios.get('/statistics/general' + params, {})
  },
  accounting(params) {
    return Axios.get('/statistics/accounting' + params, {})
  },
  sheet(limit = 10, page = 1, search) {
    return Axios.get('/statistics/sheets?limit=' + limit + '&page=' + page + search, {})
  },
  dashborard() {
    return Axios.get('/statistics/dashboard', {})
  },
}

export default stats
